import React from 'react';
import img from '../../../assets/working.png'

const Pay = () => {
    return (
        <div>
            <img src={img} className='img-fluid'></img>
        </div>
    );
};

export default Pay;